import { Dot } from "@components"
import { Chip } from "@heroui/react"
import Slot from "./Slot"
import PropTypes from "prop-types"

const CompactSlotSelector = ({ 
  guardianBookedSlots = [], 
  handleSelectSlot, 
  selectedSlot = null, 
  showSelectedSlot = true, 
  slots 
}) => {
  const getSlotStatus = (slot) => {
    if (hasGuardianBookingAtSlotTime(slot)) return "guardian_booked"
    if (slot.id === selectedSlot?.id) return "selected"
    if (slot.status === "Available") return "available" 
    return "unavailable"
  }
     
  const getTotalAvailableSlots = () => {
    return slots?.filter(slot => !hasGuardianBookingAtSlotTime(slot) && slot.status === "Available").length || 0
  }
  
  const handleUpdateSelectedSlot = (slot) => { 
    if (slot.status === "Available" && !hasGuardianBookingAtSlotTime(slot)) {
      handleSelectSlot(slot)
    }
  }

  const hasGuardianBookingAtSlotTime = (slot) => {
    return guardianBookedSlots.some(guardianBookedSlot => slot.starts_at.isSame(guardianBookedSlot))
  }

  const totalAvailableSlots = getTotalAvailableSlots()
  
  return (
    <div className="w-full p-4 rounded-lg bg-content2">
      {showSelectedSlot && (
        <div className='flex items-center justify-between mb-3'>
          <h1 className='font-semibold text-grey-700 text-md'>
            Selected Slot: { selectedSlot ? selectedSlot.starts_at.format("HH:mm") : "N/A" }
          </h1>
          
          <Chip 
            className={`${totalAvailableSlots === 0 ? "bg-danger" : "bg-available"}`}
            classNames={{ "content": "text-white font-semibold"}}
          >
            {totalAvailableSlots === 0 ? "Fully Booked" : `${totalAvailableSlots} Available Slots`}
          </Chip>
        </div>
      )}
      
      <div className="flex flex-wrap mb-3 gap-x-4 gap-y-1">
        <Dot color="available" text="Available" />
        <Dot color="unavailable" text="Unavailable (Booked or Disabled)" />
        <Dot color="guardian_booked" text="Guardian booked in for another appointment" />
        <Dot color="selected" text="Selected" />
      </div>

      <div className="grid grid-cols-6 gap-[4px]">
        {slots.map((slot) => (
          <Slot 
            key={slot.id} 
            caption={slot.starts_at.format("HH:mm")} 
            status={getSlotStatus(slot)} 
            handleClick={() => handleUpdateSelectedSlot(slot)} 
          />
        ))}
      </div>
    </div>
  );
}

CompactSlotSelector.propTypes = {
  guardianBookedSlots: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      starts_at: PropTypes.string,
    })
  ),
  handleSelectSlot: PropTypes.func.isRequired,
  showSelectedSlot: PropTypes.bool,
  selectedSlot: PropTypes.shape({
    id: PropTypes.string.isRequired,
    starts_at: PropTypes.object.isRequired,
  }),
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      starts_at: PropTypes.object.isRequired,
      status: PropTypes.string.isRequired,
    }).isRequired
  ),
};

export default CompactSlotSelector;
